import { useState } from "react";
import { CmaInstant } from "./cmaInstant";
import { LisintgDescriptionMap } from "./map";
import { OfferPrediction } from "./offerPrediction";
import { ListingPropertyInfo } from "./propertyInfo";
import { formatPrice } from "../../utils/formatPrice";
import { formatDate } from "../../utils/dateFormatter";
import type { ListingGraphs } from "../../interfaces/graphs";
// import { ChanceOfferAccepted } from "./chanceOfferAccepted";
import type { ListingDetailed } from "../../interfaces/listing";
import GrayArrowDownIcon from "../../assets/grayArrowDownIcon.svg";
import { convertToFormattedAmount } from "../../utils/convertAmount";
import PropertyDetailsIcon from "../../assets/Listing/propertyDetailsIcon.svg";
import { useShowLoginModalStore } from "../../stores/loginModalStore";
import { useAuth } from "../../context/authProvider";

interface PropertyDetailsProps {
  listing: ListingDetailed | null;
  statistics: ListingGraphs | null;
}

const PropertyDetails = ({ statistics, listing }: PropertyDetailsProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { setShowLoginModal } = useShowLoginModalStore();
  const { authenticated } = useAuth();

  if (!listing) {
    return null;
  }

  return (
    <div className="border bg-white border-[#D9D9D9] shadow-[0_2px_12.6px_0_rgba(0,0,0,0.25)] rounded-[30px] xl:py-[45px] py-[40px] xl:px-10 px-6 mt-10">
      <div
        className="text-black font-semibold text-xl flex items-center justify-between w-full cursor-pointer"
        onClick={() => setIsExpanded((prevState) => !prevState)}
        onKeyDown={() => setIsExpanded((prevState) => !prevState)}
        aria-expanded={isExpanded}
      >
        <div className="flex items-center gap-5">
          <img width={40} src={PropertyDetailsIcon} alt="" />
          <span className="text-[#333] text-3xl">Property Details</span>
        </div>

        <img
          src={GrayArrowDownIcon}
          alt="Toggle Section"
          className={`transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </div>
      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isExpanded ? "max-h-auto" : "max-h-0"
        }`}
      >
        <div className="pb-12 mb-12 border-b border-[#F3F3F3] mt-7">
          <LisintgDescriptionMap
            height="265px"
            lat={listing?.lat || 0}
            lng={listing?.long || 0}
          />
          {/* <div className="grid grid-rows-3 grid-cols-2 xl:gap-x-72 lg:gap-x-5 gap-y-9 mt-7">
						{categoryList.map((category, index) => (
							<div
								key={index}
								className="relative flex items-center justify-between before:absolute before:top-1/2 before:left-0 before:right-0 before:-translate-y-1/2 before:border before:border-dashed before:border-[#B6B9CC] before:content-[''] before:w-full before:h-[1px]"
							>
								<div className="text-xl text-[#B6B9CC] font-medium bg-white z-0 pr-7">
									{category.name}
								</div>
								<div className="z-0 pl-7 bg-white">
									<span className="bg-[#D7FFEC] text-[#0A9D57] w-11 h-11 rounded-full text-xl font-bold flex justify-center items-center">
										{category.value}
									</span>
								</div>
							</div>
						))}
					</div> */}

          <div className="mt-8">
            <CmaInstant
              address={listing?.address || ""}
              listingPrice={listing?.listPrice ?? 0}
              zlid={listing?.listingId ?? ""}
              valuation={
                statistics?.zownForecast?.final_ai_eval_for_target_property ?? 0
              }
            />
          </div>
        </div>
        {listing && (
          <ListingPropertyInfo
            tax={listing.tax}
            propertyType={listing.propertyType}
            buildingAge={listing.buildingAge}
            size={listing.size}
            lot={listing.lot}
            parking={listing.parking}
            basement={listing.basement}
            mlsNumber={listing.mlsNumber}
            dataSource={listing.dataSource}
            statusChange={listing.statusChange}
            listDate={listing.listDate}
            updatedDate={listing.updatedDate}
            style={listing.style}
            community={listing.community}
            municipality={listing.municipality}
            bed={listing.bed}
            bath={listing.bath}
            colling={""}
            rooms={listing.rooms}
            heatingType={listing.heatingType}
            heatingFuel={listing.heatingFuel}
            amenities={listing.amenities}
            garageType={listing.garageType}
            crossStreet={listing.crossStreet}
            condoFees={listing.condoFees}
            cumulativeDom={listing.cumulativeDom}
          />
        )}

        <div className="space-y-5">
          {!!listing?.history && listing?.history.length > 0 && (
            <div className="pt-12 mt-12 border-t border-[#F3F3F3] space-y-5">
              <span className="text-xl font-semibold text-z-shark">
                Listing History
              </span>
              <div className="flex flex-col rounded-[20px] overflow-hidden border border-[#D1D1D1] border-t-0">
                <div className="grid grid-cols-6 bg-[#DCE7E0] py-4 h-[72px] divide-x divide-[#456930] text-center *:flex *:items-center *:justify-center">
                  <span>Date Start</span>
                  <span>Date End</span>
                  <span>List Price</span>
                  <span>Sold Price</span>
                  <span>Event</span>
                  <span>Listing ID</span>
                </div>
                <div className="divide-y divide-[#D1D1D1] text-sm">
                  {listing?.history.map((item, index) => (
                    <div
                      key={index}
                      className={`items-center text-center ${
                        !authenticated &&
                        (item.lastStatus === "Lsd" ||
                          item.lastStatus === "Sld" ||
                          item.lastStatus === "Sc" ||
                          item.lastStatus === "Ter" ||
                          item.lastStatus === "Sus" ||
                          item.lastStatus === "Exp")
                          ? ""
                          : "grid grid-cols-6"
                      }   h-[58px] py-3 divide-x divide-[#DFDFDF] relative`}
                    >
                      {!authenticated &&
                      (item.lastStatus === "Lsd" ||
                        item.lastStatus === "Sld" ||
                        item.lastStatus === "Sc" ||
                        item.lastStatus === "Ter" ||
                        item.lastStatus === "Sus" ||
                        item.lastStatus === "Exp") ? (
                        <div
                          className="w-full"
                          onClick={() => setShowLoginModal(true)}
                        >
                          <div className="absolute inset-0 flex items-center justify-center z-10">
                            <span className="text-black font-medium">
                              Log in to view details
                            </span>
                          </div>
                          <div className="grid grid-cols-6 blur items-center justify-between  text-center divide-x divide-[#DFDFDF] relative w-full">
                            <span className="backdrop-blur-sm opacity-50 relative z-0 w-full">
                              login to view details
                            </span>
                            <span className="backdrop-blur-sm opacity-50 relative z-0 ">
                              login to view details
                            </span>
                            <span className="backdrop-blur-sm opacity-50 relative z-0">
                              login to view details
                            </span>
                            <span className="backdrop-blur-sm opacity-50 relative z-0">
                              login to view details
                            </span>
                            <span className="backdrop-blur-sm opacity-50 relative z-0">
                              login to view details
                            </span>
                            <span className="backdrop-blur-sm opacity-50 relative z-0">
                              login to view details
                            </span>
                          </div>
                        </div>
                      ) : (
                        <>
                          <span>
                            {item.listDate
                              ? formatDate(item.listDate, "date")
                              : "-"}
                          </span>
                          <span>
                            {item.endDate
                              ? formatDate(item.endDate, "date")
                              : "-"}
                          </span>
                          <span>
                            {item.listPrice
                              ? `$${formatPrice(
                                  convertToFormattedAmount(item.listPrice)
                                )}`
                              : "-"}
                          </span>
                          <span>
                            {item.soldPrice
                              ? `$${formatPrice(
                                  convertToFormattedAmount(item.soldPrice)
                                )}`
                              : "-"}
                          </span>
                          <span>{item.lastStatus ? item.lastStatus : "-"}</span>
                          <span className="text-[#0A9D57]">
                            {item.mlsNumber ? item.mlsNumber : "-"}
                          </span>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {statistics?.percentageOverAskingPrice && (
            <div className="flex flex-col border-t pt-16 !mt-16 border-[#F3F3F3]">
              <OfferPrediction
                zlid={listing?.listingId as string}
                dom={listing?.dom as number}
                comunity={listing?.community as string}
                // percentageOverAskingPrice={"sadfsadf"}
                percentageOverAskingPrice={
                  statistics?.percentageOverAskingPrice
                }
              />
            </div>
          )}
          {/* <div className="flex flex-col border-t pt-16 !mt-16 border-[#F3F3F3]">
						<ChanceOfferAccepted
							inGta={true}
							listingPrice={listing?.listPrice as string}
							dom={listing?.dom as number}
						/>
					</div> */}
        </div>
      </div>
    </div>
  );
};

export { PropertyDetails };
